<template>
  <div class="en-tips" v-show="value">
    <div class="tips-container">
      {{ tips }}
    </div>
  </div>
</template>

<script>
export default {
  name: "index.vue",
  props: {
    value: {
      type: Boolean,
      default: false
    },
    tips: {
      type: String,
      default: "操作失败"
    }
  },
  watch: {
    value(nVal) {
      if (nVal) {
        setTimeout(() => {
          this.$emit("input", false);
        }, 3000);
      }
    }
  }
};
</script>

<style lang="scss">
  .en-tips {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 15;

    .tips-container {
      position: fixed;
      top: 50%;
      left: 50%;
      font-size: 14px;
      line-height: 16px;
      width: calc(100% - 100px);
      transform: translate(-50%, -50%);
      text-align: center;
      padding: 10px 0;
      background-color: rgba(0, 0, 0, 0.7);
      color: #ffffff;
      border-radius: 30px 30px 30px;
    }
  }
</style>
